<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-toast sticky="true"> </p-toast>
<div
  class="bpt-main-content-container"
  style="overflow: auto"
  *ngIf="accessToCurriculum; else curriculumNotAvailable"
>
  <div class="flex card-container">
    <div class="label-wrapper">
      <label>{{ treeSelectPlaceHolderText }}</label>
    </div>
    <div class="flex flex-row scope-wrapper">
      <div class="tree-wrapper">
        <p-treeSelect
          selectionMode="single"
          [(ngModel)]="selectedScope"
          [options]="treeData"
          (onNodeSelect)="checkIfScopeIsSelected()"
          [filter]="true"
          [showClear]="true"
        ></p-treeSelect>
      </div>
      <div class="button-wrapper">
        <p-button
        appPreventDoubleClick
          id="addCurriculumButton"
          class="addCurriculumBtn"
          icon="fa fa-plus"
          iconPos="left"
          [disabled]="!ifScopeIsSelected"
          pTooltip="Add Training Item(s)"
          tooltipPosition="left"
          (debounceClick)="addCurriculum()"
        ></p-button>
      </div>
    </div>
  </div>
  <div class="curriculumPanelList" *ngIf="ifScopeIsSelected">
    <app-curriculum-management-panel-list
      [selectedScope]="selectedScope"
    ></app-curriculum-management-panel-list>
  </div>
</div>
<app-curriculum-slider
  *ngIf="isCurriculumSliderOpen"
  [isCurriculumSliderOpen]="isCurriculumSliderOpen"
  (isCurriculumSliderActive)="closeCurriculumSlider($event)"
  [selectedScope]="selectedScope"
  [eqmsScopeTreeNodes]="eQMSScopesTreeNode"
></app-curriculum-slider>

<ng-template #curriculumNotAvailable>
  <app-error [errorMessage]="curriculumAccessErrorMessage()"></app-error>
</ng-template>
